module.exports = __webpack_public_path__ + "/images/globe-language.e5b4fac.svg";